import { render, staticRenderFns } from "./ChatPaletteItemsInput.vue?vue&type=template&id=fdb47aba&lang=pug&"
import script from "./ChatPaletteItemsInput.vue?vue&type=script&lang=js&"
export * from "./ChatPaletteItemsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatPaletteItemsInput.vue"
export default component.exports